import { Component,OnInit} from '@angular/core';
import {AppConfig} from '../../_config';
import { DataService } from '../../services';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  
    logo = '';
    banner='';
    isLanding = false;
   
    constructor( appConfig:AppConfig) {
         this.logo = appConfig.logoPath;
         this.banner = appConfig.bannerPath;
    }

    ngOnInit(){
      if((DataService.get('isLanding'))){
        this.isLanding=true;
      }
    }

}
